export default __webpack_public_path__ + "locales/ja-JP/Webhooks.json?hash=817e6bb8267f9cb7fcf4f456bf6650b5";